import React, {useEffect, useMemo} from 'react';
import {Select, Text, Checkbox} from '@gravity-ui/uikit';
import {ActionModal, FormInput, useErrorHandler, ErrorModal} from '../../../../shared';
import {useAddClientVersionForm} from '../../model';
import {ClientVersionStore} from '../../../../entities';
import styles from './AddClientVersionModal.module.scss';

interface AddClientVersionModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const AddClientVersionModal = ({open, setOpen}: AddClientVersionModalProps) => {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    setFieldValue,
    isLoading,
    submitError,
    resetForm,
    submitForm,
  } = useAddClientVersionForm({setOpen});

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Версия приложения',
    title: 'Ошибка при добавлении версии',
  });

  const STORE_OPTIONS = useMemo(
    () => [
      {value: ClientVersionStore.AppleAppStore, content: 'Apple App Store'},
      {value: ClientVersionStore.GooglePlay, content: 'Google Play'},
      {value: ClientVersionStore.HuaweiAppGallery, content: 'Huawei AppGallery'},
      {value: ClientVersionStore.RuStore, content: 'RuStore'},
    ],
    [],
  );

  useEffect(() => {
    if (submitError) {
      handleError(submitError);
    }
  }, [submitError, handleError]);

  // Очистка формы при открытии модального окна
  useEffect(() => {
    if (open) {
      resetForm();
    }
  }, [open, resetForm]);

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        resetForm={resetForm}
        submitForm={submitForm}
        isLoading={isLoading}
        size={'m'}
        buttonsSize={'l'}
        caption={'Добавить версию'}
        textButtonApply={'Добавить'}
        textButtonCancel={'Отменить'}>
        <div className={styles.selectField}>
          <label className={styles.selectLabel}>
            Клиент <span>*</span>
          </label>
          <Select
            size="xl"
            width="max"
            placeholder="Выберите клиент"
            value={[values.store]}
            onUpdate={(value) => setFieldValue('store', value[0])}
            options={STORE_OPTIONS}
          />
          {touched.store && errors.store && (
            <Text variant="caption-2" color="danger">
              {errors.store}
            </Text>
          )}
        </div>

        <FormInput
          label="Версия"
          placeholder="Введите номер версии"
          name="versionNumber"
          type="number"
          value={values.versionNumber.toString()}
          onChange={handleChange}
          onBlur={handleBlur}
          isRequired
          error={touched.versionNumber && errors.versionNumber}
        />

        <div className={styles.checkboxContainer}>
          <Text variant="subheader-1" className={styles.checkboxTitle}>
            Обязательная
          </Text>
          <Checkbox checked={values.isMandatory} onUpdate={(checked) => setFieldValue('isMandatory', checked)} />
        </div>
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
